module.exports = __webpack_public_path__ + "static/media/icono_editar_perfil.49c2036d.svg";